import * as tslib_1 from "tslib";
import { GraphQueryable } from "./graphqueryable";
import { setup as _setup, } from "./config/graphlibconfig";
import { Groups } from "./groups";
import { Teams } from "./teams";
import { Users, User } from "./users";
import { Planner } from "./planner";
import { GraphBatch } from "./batch";
import { DirectoryObjects } from "./directoryobjects";
import { Invitations } from "./invitations";
import { Subscriptions } from "./subscriptions";
import { Security } from "./security";
import { Sites } from "./sites";
var GraphRest = /** @class */ (function (_super) {
    tslib_1.__extends(GraphRest, _super);
    function GraphRest(baseUrl, path) {
        return _super.call(this, baseUrl, path) || this;
    }
    Object.defineProperty(GraphRest.prototype, "directoryObjects", {
        get: function () {
            return new DirectoryObjects(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GraphRest.prototype, "groups", {
        get: function () {
            return new Groups(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GraphRest.prototype, "teams", {
        get: function () {
            return new Teams(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GraphRest.prototype, "me", {
        get: function () {
            return new User(this, "me");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GraphRest.prototype, "planner", {
        get: function () {
            return new Planner(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GraphRest.prototype, "users", {
        get: function () {
            return new Users(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GraphRest.prototype, "invitations", {
        get: function () {
            return new Invitations(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GraphRest.prototype, "subscriptions", {
        get: function () {
            return new Subscriptions(this);
        },
        enumerable: true,
        configurable: true
    });
    GraphRest.prototype.createBatch = function () {
        return new GraphBatch();
    };
    GraphRest.prototype.setup = function (config) {
        _setup(config);
    };
    Object.defineProperty(GraphRest.prototype, "security", {
        get: function () {
            return new Security(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GraphRest.prototype, "sites", {
        get: function () {
            return new Sites(this);
        },
        enumerable: true,
        configurable: true
    });
    return GraphRest;
}(GraphQueryable));
export { GraphRest };
export var graph = new GraphRest("v1.0");
//# sourceMappingURL=rest.js.map